import React, { useState, useReducer, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import { config, timeConverter, formatMoney } from '../helpers/constants';
import Service from "../services/service";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { IconButton, Accordion, AccordionSummary, AccordionDetails, Tooltip, Switch, FormGroup, Select, FormControlLabel, FormHelperText, Paper, Grid, Box, Typography, InputLabel, FormControl, Button, Tab, Tabs, AppBar, Dialog, List, DialogActions, DialogContent, DialogTitle, ListItem, TextField, MenuItem } from "@material-ui/core";
import IconLabel from './IconLabel';
import LoadingScreen from "./LoadingScreen";


export default function OrderList(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        fullWidth: {
            width: "100%",
            marginBottom: theme.spacing(1)
        },
    }));

    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const classes = useStyles();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        Service.getOrders().then((res) => {
            setLoading(false);
            dispatch(actions.setOrders(res.data.orders));
        });
    }, []);

    const onDownloadInvoiceClicked = (id) => {
        const url = config.backendUrl + "export/?rid=" + id;
        window.open(url, "_blank");
    }

    const onPayButtonClicked = (id) => {
        dispatch(actions.setCheckoutDetails({ paymentStep: 4, invoiceId: id, paymentStatus: "canceled", paid: false }));
        dispatch(actions.setUI( { profileDialogVisible: false, paymentDialogVisible: true }));
    }

    if (!loading && state.user.orders.length == 0) {
        return (
            <IconLabel centered label={s.userDialog.noOrders} />
        );
    }

    return (
        <div className={classes.root}>
            <LoadingScreen status={loading} />
            {state.user.orders.map((order) => {
                const dateString = timeConverter(order.date, true, s.common.dateFormat);
                const productString = order.products[0] ? order.products[0].nameShort : s.common.na;
                const hasUnpaidInvoices = order.invoices.some(inv => inv.payDate == null && inv.stornoDate == null);
                const allCancelled = !order.invoices.some(inv => inv.stornoDate == null);
                if (allCancelled) {
                    return null;
                }

                return (
                    <Accordion defaultExpanded={hasUnpaidInvoices} style={{ backgroundColor: '#EEEEEE', marginRight: 8 }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <Typography color="primary">{s.orderList.orderTitle.format(order.id, dateString, productString)} </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
                                {order.invoices.map((invoice) => {
                                    const invoiceDate = timeConverter(invoice.date, true, s.common.dateFormat);
                                    return (
                                        <div style={{ display: "flex", alignItems: "center", width: "100%", paddingTop: 8, backgroundColor: '#EEEEEE', borderTop: "1px solid white" }}>
                                            <div style={{ flex: "1 1 auto" }}>
                                                {s.orderList.invoiceTitle.format(invoice.id, invoiceDate, formatMoney(invoice.amount), invoice.currency)}
                                            </div>
                                            <div style={{ flex: "0 0 auto" }}>
                                                <IconButton onClick={() => onDownloadInvoiceClicked(invoice.id)}><CloudDownloadIcon /></IconButton>
                                            </div>
                                            <div style={{ flex: "0 0 auto" }}>
                                                {invoice.payDate ?
                                                    <Button disabled variant="contained" style={{ width: 100, backgroundColor: '#009900', color: 'white' }}>{s.userDialog.paid}</Button>
                                                    : invoice.stornoDate ?
                                                        <Button disabled variant="outlined" style={{ width: 100 }}>{s.userDialog.orderCanceled}</Button>
                                                        :
                                                        <Button onClick={() => onPayButtonClicked(invoice.id)} variant="contained" style={{ width: 100, backgroundColor: '#BB0000', color: 'white' }}>{s.userDialog.payNow}</Button>
                                                }
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </div>
    );
}